/*
export const someAction = (state) => {}
 */
import { api } from 'src/plugins/axios'

export default {
  loadLookups,
  loadPermissions,
  fixAffiliates
}

async function loadLookups({ state, commit }) {
  try {
    const lookupResponse = await api.post('/lookups/getAll')
    const lookups = lookupResponse.data.payload
    // const stateNameOptions = lookups.STATES.map(state => {
    //   return { label: state.STATE_NAME, value: state.LK_STATE_ID }
    // })
    // const stateOptions = lookups.STATES.map(state => {
    //   return { label: state.LK_STATE, value: state.LK_STATE_ID }
    // })
    // commit('setStateOptions', lookups.STATES)
    commit('setStates', lookups.STATES)
    commit('setUserTypes', lookups.USER_TYPES)
    commit('setUserStatuses', lookups.USER_STATUSES)
    commit('setSuffixes', lookups.SUFFIX_NAMES)
    commit('setDocumentTypes', lookups.DOCUMENT_TYPES)
    commit('setFileTypes', lookups.FILE_TYPES)
    commit('setEntities', lookups.ENTITIES)
    commit('setPaymentMethods', lookups.PAYMENT_METHODS)
    lookups.ORDER_TYPES = lookups.ORDER_TYPES.map(x => {
      return {
        label: x.ORDER_TYPE_NAME,
        value: x.ORDER_TYPE_ID
      }
    })
    commit('setOrderTypes', lookups.ORDER_TYPES)
    commit('setOrderStatuses', lookups.ORDER_STATUSES)
    commit('setShippingTypes', lookups.SHIPPING_TYPES)

    let hours = []
    for (var i = 1; i <= 12; i++) hours.push({ label: pad2(i), value: pad2(i) })
    let minutes = []
    for (var i = 0; i <= 59; i++) minutes.push({ label: pad2(i), value: pad2(i) })

    state.time.hours = hours
    state.time.minutes = minutes
  } catch (err) {
    console.log(err)
  }
}

async function fixAffiliates () {
  try {
    const response = await api.get('user/fixAffiliates')
    console.log('response.data', response)
  } catch (err) {
    console.log('err', err)
  }
}

async function loadPermissions ({ commit }) {
  try {
    const response = await api.post('/permissions/getAll')
    if (response && response.data) {
      const { permissions } = response.data.payload
      commit('setPermissionsList', permissions)
    }
  }
  catch (err) {
    console.log(err)
  }
}

function pad2(number) {

  return (number < 10 ? '0' : '') + number

}